<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />

  </div>
</template>

<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "ratings",
    cardSetLink: "ratings",
    item: null,
    fields: [
      {
        col:' col-12 col-md-12',
        key: "phone",
        label: "Номер телефона",
        type: "field",
        readonly:true,
        textType: "text",
      },
      {
        col:' col-12 col-md-12',
        key: "name",
        readonly:true,
        label: "Наименование",
        type: "field",
        textType: "text",
      },

      {
        col:' col-12 col-md-6',
        key: "shops_count",
        readonly:true,
        label: "Кол-во открытых ТТ",
        type: "field",
        textType: "text",
      },
      {
        col:' col-12 col-md-6',
        key: "orders_count",
        readonly:true,
        label: "Кол-во всех заказов",
        type: "field",
        textType: "text",
      },
 
      {
        col:' col-12 col-md-6',
        key: "orders_done_count",
        readonly:true,
        label: "Кол-во выполненных заказов",
        type: "field",
        textType: "text",
      },
      {
        col:' col-12 col-md-6',
        key: "purchases_total",
        readonly:true,
        label: "Кол-во проданных бутылок",
        type: "field",
        textType: "text",
      },
      {
        col:' col-12 col-md-6',
        key: "order_prices_total",
        readonly:true,
        label: "Сумма выполненных заказов",
        type: "field",
        textType: "text",
      },

      {
        col:' col-12',
        key: "role",
        label: "Роль пользователя",
        type: "select",
        modal:'role',
        selectKey: "title",
        readonly:true,
      },
    ],
  }),

  props: ["id"],
  async created() {
    // this.pushLang();
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(this.cardSetLink, this.item, this.fields);
   
    },
  },
};
</script>
<style>
</style>
